<div class="content">
  <div class="close" mat-dialog-close>
    <img
      alt="close"
      width="24"
      height="24"
      src="../../../assets/images/close.svg"
    />
  </div>
  <img src="../../../assets/images/dialog/change-commission.png" alt="" />
  <div class="button" (click)="onOk()">我知道了</div>
</div>
